import { SET_IS_READING_MODE } from '../actions/dsr-actions-types';

const INITIAL_STATE_SET_IS_READING_MODE = { results: '' }

export function setIsReadingModeReducer(state = INITIAL_STATE_SET_IS_READING_MODE, action) {
    switch (action.type) {
        case SET_IS_READING_MODE:
            return { results: action.payload }
        default:
            return state;
    }
}